import { SetupState, RuntimeConfig } from '../types';

export function buildApartmentRuntimeConfig(state: SetupState): RuntimeConfig | { error: string } {
  // Check minimal requirements
  if (!state.dormName || !state.province) {
    return { error: 'ข้อมูลหอพักยังไม่ครบถ้วน (ต้องมีชื่อและจังหวัด)' };
  }
  if (state.rooms.length === 0) {
    return { error: 'กรุณาเพิ่มตึกและห้องพักอย่างน้อย 1 ห้อง' };
  }
  const roomNames = state.rooms.map(r => r.roomName);
  const duplicates = roomNames.filter((item, index) => roomNames.indexOf(item) !== index);
  if (duplicates.length > 0) {
    return { error: `พบเลขห้องซ้ำกันในระบบ (${Array.from(new Set(duplicates)).join(', ')}) กรุณาแก้ไขไม่ให้ซ้ำกันก่อนใช้งาน` };
  }
  if (!state.elecRate || state.elecRate <= 0) {
    return { error: 'ค่าไฟต่อหน่วยต้องมากกว่า 0 บาท' };
  }
  const parsedWater = parseFloat(state.waterRatePrice);
  if (isNaN(parsedWater) || parsedWater < 0 || String(state.waterRatePrice).trim() === '') {
    return { error: 'กรุณาระบุมูลค่าค่าน้ำ หรือระบุเป็น 0 หากไม่มีค่าใช้จ่าย' };
  }
  if (!state.promptPayNumber || state.promptPayNumber.replace(/\D/g, '').length < 10) {
    return { error: 'เบอร์โทรหรือเลขผู้รับโอนเงิน PromptPay ต้องประกอบด้วยตัวเลขอย่างน้อย 10 หลัก' };
  }
  if (!state.accountName.trim()) {
    return { error: 'กรุณาระบุชื่อบัญชีผู้รับโอนตามหน้าบัตร' };
  }
  if (state.hasCommonFee) {
    const parsedCommon = parseFloat(state.commonFeePrice);
    if (isNaN(parsedCommon) || parsedCommon < 0 || String(state.commonFeePrice).trim() === '') {
      return { error: 'กรุณาระบุค่าส่วนกลาง หรือระบุเป็น 0' };
    }
  }
  if (state.hasWifiFee) {
    const parsedWifi = parseFloat(state.wifiFeePrice);
    if (isNaN(parsedWifi) || parsedWifi < 0 || String(state.wifiFeePrice).trim() === '') {
      return { error: 'กรุณาระบุค่าอินเทอร์เน็ต Wi-Fi หรือระบุเป็น 0' };
    }
  }

  const generatedAt = new Date().toISOString();

  const config: RuntimeConfig = {
    version: '1.0.0',
    generatedAt,
    source: 'dormitory-setup-wizard-local',
    dorm: {
      name: state.dormName,
      province: state.province,
      dormType: state.dormType,
      address: state.address,
      googleMapUrl: state.googleMapUrl,
    },
    rooms: {
      buildings: state.buildingsList,
      roomList: state.rooms,
    },
    billing: {
      electricityRate: state.elecRate || 0,
      electricityRateType: state.elecRateType || 'per_unit',
      waterRateType: state.waterRateType,
      waterRatePrice: parseFloat(state.waterRatePrice) || 0,
      hasCommonFee: state.hasCommonFee,
      commonFeePrice: parseFloat(state.commonFeePrice) || 0,
      commonFeeType: state.commonFeeType,
      hasWifiFee: state.hasWifiFee,
      wifiFeePrice: parseFloat(state.wifiFeePrice) || 0,
      wifiFeeType: state.wifiFeeType,
      meterRolloverLimit: state.meterRolloverLimit || 10000,
      promptPayNumber: state.promptPayNumber,
      accountName: state.accountName,
    },
    theme: {
      themeId: state.themeId,
      logoUrl: state.logoUrl,
      logoScale: state.logoScale,
      logoPositionX: state.logoPositionX,
      logoPositionY: state.logoPositionY,
    },
    integration: {
      apartmentTarget: 'PLACEHOLDER_TARGET_URL',
      slipVerificationEnabled: false, // Future placeholder, no real API keys
    },
    metadata: {
      schemaVersion: '1.0',
      createdByWizard: true,
    },
  };

  return config;
}

export function downloadRuntimeConfig(config: RuntimeConfig, filename: string = 'runtime-config.json') {
  const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(config, null, 2));
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", filename);
  document.body.appendChild(downloadAnchorNode);
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}
